import { FetchNewFinStatusReasonTagsSortTypes } from './newFinStatusReasonTagsTypes';

export const INITIAL_NEW_FIN_STATUS_REASON_TAGS_FILTERS = {};
export const INITIAL_NEW_FIN_STATUS_REASON_TAGS_PAGE = 1;
export const INITIAL_NEW_FIN_STATUS_REASON_TAGS_SORT = [
  FetchNewFinStatusReasonTagsSortTypes.CREATED_AT_DESC
];
export const INITIAL_NEW_FIN_STATUS_REASON_TAGS_LIMIT = 100;
